import { overlay } from 'overlay-kit';
export async function showCreateCollectionModal() {
  const {
    CreateCollectionModal
  } = await import('./components/CreateCollectionModal');
  overlay.open(({
    unmount
  }) => <CreateCollectionModal onClose={unmount} />, {
    overlayId: 'create-collection-modal'
  });
}